import React, { createContext } from "react";

export default createContext({
    users: [],
    conversations: [],
    conversationsFull: [],
    selectedUserId: null,
    selectUserId: () => {},
    selectedConversationId: null,
    selectConversationId: () => {},
    getUserById: () => {},
    getConversationById: () => {},
    messagingDocListener: {},
    conversationQueryListener: {}
});
